import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchCustomer, signInRequest } from 'actions/customerDetail';
import { hideModalAction } from 'actions/signinWithSms';

let _content = null;

const CustomerDetail = (props) => {
  const { fetchCustomer, signInRequest, customer } = props;
  const [customerPk, setCustomerPk] = useState(-1);

  useEffect(() => {
    const { customerPk } = props.match.params;
    setCustomerPk(parseInt(customerPk, 10));
    fetchCustomer(customerPk);
  }, []);

  const attemptForSignIn = () => {
    signInRequest({ ...customer });
  };

  return (
    _content &&
    _content({
      props,
      customerPk,
      attemptForSignIn,
    })
  );
};

const mapStateToProps = (state) => ({
  smsExpireDate: state.signinWithSms.expireDate,
  smsModalVisibility: state.signinWithSms.smsModalVisibility,
  smsPending: state.signinWithSms.pending,
  smsError: state.signinWithSms.error,
  customer: state.customerDetail.customer,
  pending: state.customerDetail.pending,
  error: state.customerDetail.error,
  redirect: state.customerDetail.redirect,
});

const mapDispatchToProps = {
  fetchCustomer,
  signInRequest,
  hideModalAction,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(CustomerDetail);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/customer/customerDetail/index.js